import React from "react";
import "./Download_Now.css";

const Download_Now = () => {
  return (
    <section id="download_now" className="download_now">
      <div className="container p-0">
        <div className="download_content_holder">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-7 col-md-7 col-sm-6 col-12 order-lg-1">
              <div className="right_side_holder">
                <div className="download_title_holder">
                  <h2 className="download_title">Download the App!</h2>
                </div>

                <div className="levelup_holder">
                  <p className="level_up">Ready to level up?</p>
                </div>

                <div className="join_text_holder">
                  <p className="join_text">
                    Join thousands of users and gym owners transforming the
                    fitness industry.
                  </p>
                </div>
                <div className="buttons_holder">
                  <div className="download_btn_holder">
                    <img
                      src="/Assets/images/footer/playstore.png"
                      alt="download-btn"
                      className="download_btn"
                      onClick={() =>
                        window.open("https://play.google.com/store/apps/details?id=com.gymify.customer", "_blank")
                      }
                    />
                    <p className="user">User App</p>
                  </div>
                  <div className="download_btn_holder">
                    <img
                      src="/Assets/images/footer/playstore.png"
                      alt="download-btn"
                      className="download_btn"
                      onClick={() =>
                        window.open("https://play.google.com/store/apps/details?id=com.gymify.owner", "_blank")
                      }
                    />
                    <p className="user">Gym Owner App</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-5 col-sm-6 col-12 order-lg-2">
              <div className="side_image_holder">
                <img
                  src="/Assets/images/download-banner/phone-group-img.png "
                  alt="side-img"
                  className="side_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download_Now;
